import React from 'react'
import './header.css'
import CTA from './CTA'
import ME from '../../assets/IMG6821.JPG'
import HeaderSocials from './HeaderSocials'

const Header = () => {
  return (
    <header id="home">
      <div className="container header_container">
        <h5>Hello I'm</h5>
        <h1>Angela Tseng</h1>
        <h5 className="text-light">Systems Administrator / Cloud Engineer</h5>

        <CTA />
        <HeaderSocials />

        <div className="me">
          <img src={ME} alt="Portrait" />
        </div>

        <a href="#contact" className='scroll_down'>Scroll Down</a>
      </div>
    </header>
  )
}

export default Header
